/*
 * DEVELOPMENT
 */
export const environment = {
  production: false,
  apiUrl: "https://api.dev.amlcare.io/",
  authenticationUrl: "https://auth.dev.amlcare.io/",
  translationFileUrl: "https://flowtribe-translation.s3.eu-central-1.amazonaws.com/amlcare/app-panel/",
  /*
   * Features
   */
  amlEduction: false,
  sampleFileStorageUrl: "https://storage.googleapis.com/amlco-dev",

  supportUrl: "https://accounton.freshdesk.com/support/solutions/101000256921",
  integrationsUrl: "https://integrations.dev.amlcare.io/",
  accountonIntegrationsUrl: "https://integrations.dev.accounton.io/",
  minfinMasterUrl: "https://v2.minfin.dev.accounton.io/",

  accountonUrl: "https://backoffice.dev.accounton.io/",
  accountonOAuthUrl: "https://auth.dev.accounton.io/",
  accountonOAuthClientID: "amlcare-frontend",

  productFruitsWorkspaceCode: null
};
